GuidedActionCreator = require 'actions/abstract/GuidedActionCreator'
ActionTypes = require 'constants/ActionTypes'
DashboardAPI = require 'api/DashboardAPI'

class ResponseTimeActionCreator extends GuidedActionCreator
  get: (data, onSuccessCallback, onErrorCallback) =>
    @dispatch type: ActionTypes.RESPONSE_TIME_STAT_REQUESTING

    DashboardAPI.getResponseTime(
      data
      (json) =>
        if json.success
          onSuccessCallback?()
          @dispatch
            type: ActionTypes.RESPONSE_TIME_STAT_SUCCESS
            payload: json.data
        else
          onErrorCallback?()
          @dispatch
            type: ActionTypes.RESPONSE_TIME_STAT_ERROR
            payload: json.error
      (response) =>
        onErrorCallback?
        msg = 'An error occurred while getting response time statistic'
        @dispatch
          type: ActionTypes.RESPONSE_TIME_STAT_ERROR
          payload: msg
    )

module.exports = ResponseTimeActionCreator